export const BIA_IMPACT_STATUS_KEYS = ['very_low', 'low', 'medium', 'high', 'critical'];

/**
 * Map raw average (0–5) to impact status band without rounding.
 * @param {number} average
 * @returns {string}
 */
export function resolveStatusFromAverage(average) {
    if (average < 1) return 'very_low';
    if (average < 2) return 'low';
    if (average < 3) return 'medium';
    if (average < 4) return 'high';
    return 'critical';
}

/**
 * Derive BIA impact status from summary row horizon scores (0–5).
 * @param {Array<{ score?: number|null }>|null|undefined} horizonScores
 * @returns {{ average: number|null, status: string }}
 */
export function deriveBiaImpactStatus(horizonScores) {
    const scores = (horizonScores || [])
        .map((h) => h.score)
        .filter((s) => typeof s === 'number' && Number.isFinite(s));

    if (!scores.length) {
        return { average: null, status: 'very_low' };
    }

    const average = Math.round((scores.reduce((a, b) => a + b, 0) / scores.length) * 100) / 100;
    const status = resolveStatusFromAverage(average);
    return { average, status };
}
